export const SELECTED_UNIT_ID = 'selected-unit-id';
export const EMPTY_OPTIONS = [] as any[];
export const VIDEO_UPLOAD_CONTAINER_ID = 'mission-record-video-upload';
export const OTHER_UV_ID = 'Інший номер';
export const MGRS_PATTERN =
  /^(?:[ABYZ]|(?:[1-9]|[1-5]\d|60)[C-HJ-NP-X])[ \t]*[A-HJ-NP-Z][A-HJ-NP-V][ \t]*(?:\d{2}|\d{4}|\d{6}|\d{8}|\d{10}|\d[ \t]+\d|\d{2}[ \t]+\d{2}|\d{3}[ \t]+\d{3}|\d{4}[ \t]+\d{4}|\d{5}[ \t]+\d{5})$/i;
